var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentType === "list")?_c('UserList',{attrs:{"loading":_vm.loading,"users":_vm.users}}):(_vm.componentType === "createOrEdit")?_c('UserCreateOrEdit',{attrs:{"loading":_vm.loading,"user":_vm.user()},on:{"save":_vm.save}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }